import { render, staticRenderFns } from "./tableAsinColumn.vue?vue&type=template&id=2a7e718d&scoped=true"
import script from "./tableAsinColumn.vue?vue&type=script&lang=js"
export * from "./tableAsinColumn.vue?vue&type=script&lang=js"
import style0 from "./tableAsinColumn.vue?vue&type=style&index=0&id=2a7e718d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e718d",
  null
  
)

export default component.exports